import {
  Bars3Icon
} from '@heroicons/react/24/outline';
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";

import { useLocalStorage } from "../../hooks";
import { userState } from "../../redux/reducers/userReducer";


import axios from "axios";
import WarningDialog from "../../modals/confirmationModals/WarningDialog";
import * as dashboardActions from "../../redux/reducers/dashboardReducer";
import { clearLoadingData, loadingState, setGlobalLoading } from "../../redux/reducers/loadingReducer";
import { clearSchoolData } from "../../redux/reducers/schoolReducer";
import * as userActions from "../../redux/reducers/userReducer";
import { getUrlForUsers, isRootDomain, redirectWithwwwRootDomain } from "../../utils/confighelpers";
import TwAppBar from "./TwAppBar";
import TwAppFooter from "./TwAppFooter";
import TwSectionHeadings from "./TwSectionHeadings";
import TwSidebar from "./TwSidebar";
import axiosInstance from '../../utils/axiosInstance';
import { defaultDomainList } from '../../utils/constants';
import { useTenant } from '../../provider/TenantProvider';

export default function TwMainLayout(props) {
  const {
    children,
    loading = false,
    headTitle = "",
    subHeader = null,
    showCalendarIcon,
    checkSession = true,
    showHeader = true,
    showSidebar = true,
    fullScreen = false,
    userType = "teacher",
  } = props
  const { tenant, tenantData, tenantLoading } = useTenant();
  const location = useLocation();
  const dispatch = useDispatch();
  const [userToken, setUserToken] = useLocalStorage("userToken");
  const loadingReduxState = useSelector(loadingState);
  const userReduxState = useSelector(userState);
  const navigate = useNavigate();
  const [openSubscriptionWarningDialog, setOpenSubscriptionWarningDialog] = React.useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(false)


  const [screenSizeType, setScreenSizeType] = React.useState("");


  React.useEffect(() => {
    dispatch(setGlobalLoading(loading));
  }, [loading]);


  const clearSessionData = async () => {
    localStorage.removeItem("userToken");
    localStorage.removeItem("persist:root");
    dispatch(userActions.clearUserData());
    dispatch(clearSchoolData());
    dispatch(dashboardActions.clearDashboardData());
    await setUserToken("");
    dispatch(clearLoadingData());
    // window.location.href = "/";
  }

  const getAvailableUserAccess = async () => {
    if (userToken && userReduxState.businessType) {
      const config = {
        method: "get",
        url: `${getUrlForUsers()}getAvailableUserAccess/${userReduxState.businessType}`,
        // headers: {
        //   "x-access-token": userToken,
        // },
      };
      const request = await axiosInstance(config);
      // .catch(async (e) => {
      //   console.log("getAvailableUserAccess", e);
      //   clearSessionData()
      //   window.location.href = "/";
      // });
      setOpenSubscriptionWarningDialog(false)
      if (request?.data && request.data.statusCode === 200) {
        const responseDetails = request.data.data;
        if (responseDetails.subscriptionDetails.primarySubscription.allowbusinessAccess === false) {
          // setOpenSubscriptionWarningDialog(responseDetails.subscriptionDetails.primarySubscription.allowbusinessAccess)
          setOpenSubscriptionWarningDialog(true)
        }
      }
    } else {
      // clearSessionData()
    }
  }

  React.useEffect(() => {
    if (location?.pathname && location.pathname !== "/businessprofilesetup/subscription/upgrade" && !location.pathname.startsWith("/start/")) {
      (async () => {
        try {
          await getAvailableUserAccess()
        } catch (error) {

        }
      })();
    }
  }, [location]);

  const logout = async () => {
    try {
      dispatch(setGlobalLoading(true));
      await axios.put(
        `${getUrlForUsers()}logoutUser`,
        {},
        {
          headers: {
            "Content-Type": "application/json",
            "x-access-token": userToken,
          },
        }
      );
    } catch (err) {
      console.log("error", err);
    } finally {
      clearSessionData()
      // navigate("/", { replace: true });
      window.location.href = "/";
    }
  };

  if (checkSession) {
    if ((userToken === undefined || userToken == "")) {
      // navigation("/home/dashboard");
      window.location.href = "/";
    }
  }

  React.useEffect(() => {
    // console.log("userType", userReduxState?.userData?.userType + "!==" + userType);

    if (userType
      && userType !== "skip"
      // && defaultDomainList.indexOf(tenant) < 0
      && location?.pathname !== undefined
      && location?.pathname !== "/"
      && userReduxState?.userData !== undefined
      && userReduxState?.userData?.userType !== undefined
      && userReduxState?.userData?.userType !== userType
    ) {
      window.location.href = "/";
    }
  }, [userReduxState?.userData?.userType]);

  React.useEffect(() => {
    // console.log("userType", userType);
    // console.log("userReduxState?.userData?.userType", userReduxState?.userData);

    let pageTitle = "FitClub Pro";
    let pageFavicon = "/logo.png";
    pageFavicon = "/FitClubPro_favicon.png";
    if (userReduxState?.userData !== undefined
      && userReduxState?.userData?.userType !== undefined
      && userReduxState?.userData?.userType === "teacher"
      && userReduxState?.userData?.myBusinessProfile.businessName !== undefined
    ) {
      pageTitle = userReduxState?.userData?.myBusinessProfile?.businessName || "FitClub Pro"
      pageFavicon = userReduxState?.userData?.myBusinessProfile?.logo || "/logo.png";
    } else if (userReduxState?.userData !== undefined
      && userReduxState?.userData?.userType !== undefined
      && userReduxState?.userData?.userType === "student"
      && tenantLoading == false
      && (tenantData.businessName && tenantData.logo && tenantData.businessName != "DEFAULT" && tenantData.businessName != "NOTFOUND")
    ) {
      pageTitle = tenantData.businessName
      pageFavicon = tenantData.logo;
    } else if ((userReduxState?.userData === undefined || Object.keys(userReduxState?.userData).length === 0)
      && tenantLoading == false
      && (tenantData.businessName && tenantData.logo && tenantData.businessName != "DEFAULT" && tenantData.businessName != "NOTFOUND")
    ) {
      pageTitle = tenantData.businessName
      pageFavicon = tenantData.logo;
    }
    document.title = pageTitle;
    const favicon = document.getElementById("favicon");
    if (favicon) {
      favicon.href = pageFavicon;
    }
    const appleFavicon = document.getElementById("apple-favicon");
    if (appleFavicon) {
      favicon.href = pageFavicon;
    }
  }, [userReduxState?.userData?.userType, tenantData]);

  if (isRootDomain()) {
    console.log("Root domain (no subdomain)");
    redirectWithwwwRootDomain()
  }

  return (<>
    {fullScreen ? (
      <>
        {children}
        {(props.footerTitle || props.footerActions) && (<TwAppFooter
          {...props}
        />)}
      </>
    ) : (
      <>
        {showSidebar && (<TwSidebar
          sidebarOpen={sidebarOpen}
          setSidebarOpen={setSidebarOpen}
          logout={logout}
        />)}

        <div className="flex flex-col min-h-screen [md:h-screen] lg:pl-64">
          {(showHeader || showSidebar) && (<div className="sticky top-0 z-40 flex h-16 shrink-0 items-center gap-x-4 border-b border-gray-200 bg-white px-4 shadow-md sm:gap-x-6 sm:px-6 lg:px-8">
            {showSidebar && (
              <button type="button" onClick={() => setSidebarOpen(true)} className="-m-2.5 p-2.5 text-gray-700 lg:hidden">
                <span className="sr-only">Open sidebar</span>
                <Bars3Icon aria-hidden="true" className="size-6" />
              </button>
            )}
            {/* <TwAppBarIconButton
              className="text-gray-700 lg:hidden"
              srTitle={"Open sidebar"}
              iconName={Bars3Icon}
              onClick={() => setSidebarOpen(true)}
            /> */}
            {/* <button type="button" onClick={() => setSidebarOpen(true)} className="-m-2.5 p-2.5 text-gray-700 lg:hidden">
            <span className="sr-only">Open sidebar</span>
            <Bars3Icon aria-hidden="true" className="size-6" />
          </button> */}

            {showSidebar && (<div aria-hidden="true" className="h-6 w-px bg-gray-900/10 lg:hidden" />)}

            {showHeader && (<TwAppBar
              {...props}
              logout={logout}
            />)}
          </div>)}

          <main className="flex flex-col h-full [mb-auto] pb-5 max-w-7xl">
            {(props.headTitle || props.breadcrumbs || props.headActions) && (<TwSectionHeadings
              {...props}
            />)}
            {children}
            {loadingReduxState.sectionLoading !== undefined && loadingReduxState.sectionLoading === true
              && (<div className="lg:ml-64 absolute top-0 left-0 right-0 bottom-0 bg-gray-800/50 backdrop-blur-lg z-10 flex items-center justify-center">
                <div className="animate-spin rounded-full h-12 w-12 border-8 border-t-transparent border-gray-100"></div>
              </div>)}
          </main>
          {(props.footerTitle || props.footerActions) && (<TwAppFooter
            {...props}
          />)}
        </div>
      </>
    )}
    <WarningDialog
      open={openSubscriptionWarningDialog}
      text={`You don't have an active subscription. If you need to access ${userReduxState.businessType} business you will have to purchase/upgrade your subscription.`}
      // isCloseBtn={false}
      // btnCloseText={"Close"}
      btnSubmitText={"Update Subscription"}
      onClose={() => setOpenSubscriptionWarningDialog(false)}
      onSubmit={async () => {
        setOpenSubscriptionWarningDialog(false)
        navigate("/businessprofilesetup/subscription/upgrade", {
          state: {
            // origin: "paymentprofile",
            origin: "upgradeSubscription",
            from: "full",
            // origin: "mybilling",
          },
          replace: true
        });
      }}
    />
  </>);
}
